import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
@Component({
  selector: 'app-viewstockmanagement',
  templateUrl: './viewstockmanagement.component.html',
  styleUrls: ['./viewstockmanagement.component.css']
})
export class ViewstockmanagementComponent implements OnInit {
  getstockviewApi: string;
  getval:any;
  farmname:any;
  viewspeciesname:any
  viewage:any;
  birthdate:any;
  transfdate:any;
   datepurchase:any;
    datedelete:any;
  returnUrl= "/dashboard/stockmanagement";
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    let stockId = sessionStorage.getItem('StockId');
    this.getstockviewApi= "/stock_management/"+stockId;
    (await this.commonService.getApi(this.getstockviewApi)).subscribe(
      res => { 
        if(res.data.tnsm_date_of_birth!=null){
          var date=res.data.tnsm_date_of_birth;
          this.birthdate = date.split('T');
        }
        if(res.data.tnsm_date_of_transfer!=null){
          var transferdate=res.data.tnsm_date_of_transfer;
          this.transfdate = transferdate.split('T');
        }
        if(res.data.tnsm_date_of_purchase!=null){
          var purchasedate=res.data.tnsm_date_of_purchase;
          this. datepurchase = purchasedate.split('T');
        }
        if(res.data.tnsm_date_of_deletion!=null){
          var deletiondate=res.data.tnsm_date_of_deletion;
          this. datedelete = deletiondate.split('T');
        }

         $("#Gender").text(res.data.tnsm_sex),
        $("#farmname").text(res.data.farm_name),
         $("#Speciesname").text(res.data.species_name),
         $("#agetype").text( res.data.age_group +' / '+ res.data.weeks + ' days'),   
       $("#BreedName").text(res.data.breed_name),
       $("#getWeight").text(res.data.tnsm_weight),
        $("#getHeight").text(res.data.tnsm_height),
        $("#animalid").text(res.data.tnsm_animal_code),
     this.getval=res.data.tnsm_status;
        if (this.getval==1) 
{
  $("#Status").text("Active").addClass("green");
}
if (this.getval==0) {
 $("#Status").text("Inactive").addClass("red");
}    
      
      })
  }
  stockmanagement(){
    this.router.navigate([this.returnUrl]);
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
